import { createReducer, on } from '@ngrx/store';
import * as OrganizationActions from './organizations.actions';
import { initialOrganizationState } from './organizations.state';
import { IFileUploadStatus } from '@shared/utility/global-enums';
import { UsageTypeIDTitle } from './organizations.interface';

const usageTypeidTitle = UsageTypeIDTitle;

export const OrganizationReducer = createReducer(
  initialOrganizationState,

  on(OrganizationActions.setDepartmentUID, (state, { departmentUID }) => ({
    ...state,
    departmentUID: departmentUID,
    filter: { ...initialOrganizationState.filter },
  })),
  on(
    OrganizationActions.setSelectedOrganizationUID,
    (state, { organizationUID }) => ({
      ...state,
      selectedOrganizationUID: organizationUID,
    }),
  ),
  on(OrganizationActions.filterChange, (state, { filter }) => ({
    ...state,
    filter: {
      StatusId: filter.StatusId,
      CountryId: filter.CountryId,
      WeatherDataRequired: filter.WeatherDataRequired,
    },
  })),
  on(
    OrganizationActions.GetOrganizationsFiltersSuccess,
    (state, { filterOptions }) => ({
      ...state,
      filterOptions,
    }),
  ),
  on(
    OrganizationActions.deleteOrganizationSuccess,
    (state, { organizationUID }) => ({
      ...state,
      organizations: {
        ...state.organizations,
        items: state.organizations.items.filter(
          (org) => org.organizationUID !== organizationUID,
        ),
        pagingInfo: {
          ...state.organizations.pagingInfo,
          totalCount: state.organizations.pagingInfo.totalCount - 1,
        },
      },
    }),
  ),
  on(
    OrganizationActions.UpdateOrganizationSuccess,
    (state, { updatedOrganization }) => ({
      ...state,
      organizations: {
        ...state.organizations,
        items: state.organizations.items.map((org) =>
          org.organizationUID === updatedOrganization.organizationUID
            ? updatedOrganization
            : org,
        ),
      },
      drawersState: { ...state.drawersState, organizationEditDrawer: true },
    }),
  ),
  on(
    OrganizationActions.createNewOrganizationSuccess,
    (state, { createdOrganization }) => ({
      ...state,
      organizations: {
        ...state.organizations,
        items: [createdOrganization, ...state.organizations.items],
        pagingInfo: {
          ...state.organizations.pagingInfo,
          totalCount: state.organizations.pagingInfo.totalCount + 1,
        },
      },
      drawersState: { ...state.drawersState, organizationEditDrawer: true },
    }),
  ),
  on(
    OrganizationActions.GetOrganizationsFiltersSuccess,
    (state, { filterOptions }) => ({
      ...state,
      filterOptions,
    }),
  ),
  on(OrganizationActions.getOrganization, (state, { organizationUID }) => ({
    ...state,
    newOrganization: false,
    selectedOrganization: state.organizations.items.find(
      (org) => org.organizationUID === organizationUID,
    ),
    drawersState: { ...state.drawersState, organizationEditDrawer: false },
  })),
  on(OrganizationActions.setNewOrganization, (state) => ({
    ...state,
    newOrganization: true,
    selectedOrganization: initialOrganizationState.selectedOrganization,
    drawersState: { ...state.drawersState, organizationEditDrawer: false },
  })),
  on(OrganizationActions.searchChange, (state, { search }) => ({
    ...state,
    search,
  })),
  // on(
  //   OrganizationActions.selectRootOrganization,
  //   (state, { organizationUID }) => ({
  //     ...state,
  //     newOrganization: false,
  //     selectedRootOrganization: state.organizations.items.find(
  //       (org) => org.organizationUID === organizationUID,
  //     ),
  //   }),
  // ),
  // on(
  //   OrganizationActions.selectRootOrganizationSuccess,
  //   (state, { organization }) => ({
  //     ...state,
  //     selectedOrganization: organization,
  //   }),
  // ),
  on(OrganizationActions.getOrganizationSuccess, (state, { organization }) => ({
    ...state,
    selectedOrganization: organization,
    drawersState: { ...state.drawersState, organizationEditDrawer: false },
  })),
  on(OrganizationActions.getOrganizationList, (state, { pagingRequest }) => ({
    ...state,
    organizations: { ...state.organizations, items: [], isLoading: true },
    pagingRequest: pagingRequest,
  })),
  on(
    OrganizationActions.getOrganizationListSuccess,
    (state, { organizations, organizationTypes }) => ({
      ...state,
      organizations: {
        items: organizations.items,
        pagingInfo: organizations.pagingInfo,
        isLoading: false,
      },
      organizationTypes: organizationTypes,
    }),
  ),
  on(
    OrganizationActions.getOrganizationApiCredentialsSuccess,
    (state, { organizationUID, orgApiCredentials }) => ({
      ...state,
      organizationApiCredentials: {
        organizationUID,
        apiCredentials: orgApiCredentials,
      },
      drawersState: {
        ...state.drawersState,
        apiCredentialsSettingsDrawer: false,
      },
    }),
  ),
  on(
    OrganizationActions.getOrganizationRequestsSuccess,
    (state, { organizationUID, orgRequestList }) => ({
      ...state,
      organizationsRequestList: {
        organizationUId: organizationUID,
        scheduleTimeZoneID: state.organizations.items.find(
          (item) => item.organizationUID === organizationUID,
        ).scheduleTimeZoneID,
        organizationRequests: orgRequestList,
      },
      drawersState: {
        ...state.drawersState,
        requestEditDrawer: false,
      },
    }),
  ),
  on(
    OrganizationActions.updateOrganizationRequests,
    (state, { organizationUID, organizationRequests }) => ({
      ...state,
      organizationsRequestList: {
        organizationUId: organizationUID,
        scheduleTimeZoneID:
          state.organizations.items.find(
            (item) => item.organizationUID === organizationUID,
          )?.scheduleTimeZoneID || '',
        organizationRequests: organizationRequests,
      },
      drawersState: {
        ...state.drawersState,
        requestEditDrawer: false,
      },
    }),
  ),
  on(OrganizationActions.updateOrganizationRequestsSuccess, (state) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      requestEditDrawer: true,
    },
  })),
  on(OrganizationActions.updateOrganizationApiCredentialsSuccess, (state) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      apiCredentialsSettingsDrawer: true,
    },
  })),
  on(
    OrganizationActions.getOrganizationTypesSuccess,
    (state, { organizationTypes }) => ({
      ...state,
      organizationTypes: organizationTypes,
    }),
  ),
  on(
    OrganizationActions.getDataSourceSettingsListSuccess,
    (state, { organizationUID, dataSourceSettingsList }) => ({
      ...state,
      dataSourcesSettingsList: {
        dataSourceTypes: state.dataSourcesSettingsList.dataSourceTypes,
        organizationUId: organizationUID,
        dataSourceSettings: dataSourceSettingsList,
        selectedDataSourceSettings: null,
        isDataSourceSettingsNew: null,
      },
    }),
  ),

  on(OrganizationActions.SetNewDataSourceSettings, (state, actions) => ({
    ...state,

    selectedDataSourceSettings: {
      ...initialOrganizationState.selectedDataSourceSettings,
      utilityServiceID: actions.utilityServiceID,
      isDataSourceSettingsNew: true,
      usedDataSourceTypes: state.dataSourcesSettingsList.dataSourceSettings[
        actions.utilityServiceID - 1
      ].dataSources.map((dataSourceTypes) => dataSourceTypes.sourceTypeID),
    },
    drawersState: {
      ...state.drawersState,
      dataSourceSettingsDrawer: false,
    },
  })),
  on(OrganizationActions.showIconUploadPopup, (state, actions) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      uploadOrganizationIconPopupVisible: true,
    },
  })),
  on(OrganizationActions.putIconToSelectedOrganization, (state, actions) => ({
    ...state,
    selectedOrganization: {
      ...state.selectedOrganization,
      organizationMedia: {
        icon: actions.iconImage,
        logo: null,
        uploadedImageUID: actions.uploadedImageUID,
      },
    },
  })),
  on(OrganizationActions.deleteOrganizationIcon, (state, actions) => ({
    ...state,
    selectedOrganization: {
      ...state.selectedOrganization,
      organizationMedia: {
        icon: null,
        logo: null,
        uploadedImageUID: null,
      },
    },
  })),
  on(OrganizationActions.closeIconUploadPopup, (state, actions) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      uploadOrganizationIconPopupVisible: false,
    },
  })),
  on(OrganizationActions.addDataSourceSettingsSuccess, (state) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      dataSourceSettingsDrawer: true,
    },
  })),
  on(OrganizationActions.EditDataSourceSettingsSuccess, (state) => ({
    ...state,
    drawersState: {
      ...state.drawersState,
      dataSourceSettingsDrawer: true,
    },
  })),
  on(OrganizationActions.GetLastProcessingSuccess, (state, action) => ({
    ...state,
    lastProcessing: action.lastProcessing,
  })),
  on(
    OrganizationActions.SetEditDataSourceSettings,
    (state, { utilityServiceID, dataSourceSettingUID }) => {
      const dataSourceSettings =
        state.dataSourcesSettingsList.dataSourceSettings[utilityServiceID - 1]
          .dataSources;
      const selectedSettings =
        dataSourceSettings.find(
          (value) => value.dataSourceSettingUID === dataSourceSettingUID,
        ) || null;

      const usedDataSourceTypes = dataSourceSettings
        .filter(
          (dataSource) =>
            dataSource.sourceTypeID !== selectedSettings.sourceTypeID,
        )
        .map((dataSource) => dataSource.sourceTypeID);

      return {
        ...state,
        selectedDataSourceSettings: {
          ...state.selectedDataSourceSettings,
          utilityServiceID,
          settings: selectedSettings,
          isDataSourceSettingsNew: false,
          usedDataSourceTypes,
        },
        drawersState: {
          ...state.drawersState,
          dataSourceSettingsDrawer: false,
        },
      };
    },
  ),
  on(OrganizationActions.setDataSourceSettingsParams, (state, params) => ({
    ...state,
    selectedDataSourceSettings: {
      ...state.selectedDataSourceSettings,
      settings: {
        ...state.selectedDataSourceSettings.settings,
        sourceTypeID: params.sourceTypeID,
        parameters: state.dataSourcesSettingsList.dataSourceTypes.find(
          (item) => item.sourceTypeID === params.sourceTypeID,
        ).parameters,
      },
    },
  })),
  on(OrganizationActions.GetDataSourceTypesSuccess, (state, sourceTypes) => ({
    ...state,
    dataSourcesSettingsList: {
      ...state.dataSourcesSettingsList,
      dataSourceTypes: sourceTypes.dataSourceTypes,
    },
  })),
  on(OrganizationActions.getDataSourceSettingsSuccess, (state, action) => ({
    ...state,
    dataSourcesSettingsList: {
      ...state.dataSourcesSettingsList,
      selectedDataSourceSettings: action.dataSourceSetting,
      isDataSourceSettingsNew: false,
    },
  })),
  on(OrganizationActions.validationError, (state, { ValidationErrors }) => {
    return {
      ...state,
      ValidationErrors,
    };
  }),
  on(OrganizationActions.resetOrganizationFilterAndSearch, (state) => ({
    ...state,
    filter: { ...initialOrganizationState.filter },
    search: '',
    organizations: { ...initialOrganizationState.organizations },
  })),
  on(OrganizationActions.showErrors, (state, { message }) => ({
    ...state,
    loading: false,
    // organizations: { ...initialOrganizationState.organizations },
    ValidationErrors: message,
  })),
  on(OrganizationActions.resetOrganizationState, (state) => ({
    ...initialOrganizationState,
  })),

  on(
    OrganizationActions.getChannelConfigurationsSuccess,
    (state, { organizationUID, channelConfigurationList }) => {
      const updatedChannelConfigurationsList = channelConfigurationList.map(
        (config) => {
          const orderMappings = [...config.mappings].sort(
            (a, b) => a.index - b.index,
          );
          const updatedMappings = orderMappings.map((mapping) => {
            const usageTypeName = UsageTypeIDTitle[mapping.usageTypeID];
            return {
              ...mapping,
              usageTypeName,
            };
          });

          return {
            ...config,
            mappings: updatedMappings,
          };
        },
      );

      return {
        ...state,
        organizationChannelConfigurationList: {
          organizationUID,
          channelConfigurationsList: updatedChannelConfigurationsList,
        },
      };
    },
  ),
  on(
    OrganizationActions.addChannelConfigurationsSuccess,
    (state, { channelConfiguration }) => {
      const updatedChannelConfigurationsList = (channelConfiguration) => {
        const orderMappings = [...channelConfiguration.mappings].sort(
          (a, b) => a.index - b.index,
        );
        const updatedMappings = orderMappings.map((mapping) => {
          const usageTypeName = UsageTypeIDTitle[mapping.usageTypeID];
          return {
            ...mapping,
            usageTypeName,
          };
        });

        return {
          ...channelConfiguration,
          mappings: updatedMappings,
        };
      };

      return {
        ...state,
        organizationChannelConfigurationList: {
          ...state.organizationChannelConfigurationList,
          channelConfigurationsList: [
            ...state.organizationChannelConfigurationList
              .channelConfigurationsList,
            updatedChannelConfigurationsList(channelConfiguration),
          ],
        },
        drawersState: {
          ...initialOrganizationState.drawersState,
          channelConfigurationDrawer: true,
        },
      };
    },
  ),
  on(
    OrganizationActions.setSelectedChannelConfigurations,
    (state, { channelConfiguration }) => ({
      ...state,
      selectedChannelConfigurations: channelConfiguration,
      drawersState: {
        ...state.drawersState,
        channelConfigurationDrawer: false,
      },
    }),
  ),
  on(
    OrganizationActions.editChannelConfigurationsSuccess,
    (state, { channelConfiguration }) => {
      const updatedChannelConfigurationsList = (channelConfiguration) => {
        const orderMappings = [...channelConfiguration.mappings].sort(
          (a, b) => a.index - b.index,
        );
        const updatedMappings = orderMappings.map((mapping) => {
          const usageTypeName = UsageTypeIDTitle[mapping.usageTypeID];
          return {
            ...mapping,
            usageTypeName,
          };
        });

        return {
          ...channelConfiguration,
          mappings: updatedMappings,
        };
      };

      return {
        ...state,
        organizationChannelConfigurationList: {
          ...state.organizationChannelConfigurationList,
          channelConfigurationsList: [
            ...state.organizationChannelConfigurationList.channelConfigurationsList.filter(
              (cha) =>
                cha.channelConfigurationUID !==
                channelConfiguration.channelConfigurationUID,
            ),
            updatedChannelConfigurationsList(channelConfiguration),
          ],
        },
        drawersState: {
          ...initialOrganizationState.drawersState,
          channelConfigurationDrawer: true,
        },
      };
    },
  ),
  on(
    OrganizationActions.deleteChannelConfigurationsSuccess,
    (state, { channelConfigurationUID }) => ({
      ...state,
      organizationChannelConfigurationList: {
        ...state.organizationChannelConfigurationList,
        channelConfigurationsList:
          state.organizationChannelConfigurationList.channelConfigurationsList.filter(
            (config) =>
              config.channelConfigurationUID !== channelConfigurationUID,
          ),
      },
    }),
  ),
  on(
    OrganizationActions.getDeliveryMethodsSuccess,
    (state, { deliveryMethods }) => ({
      ...state,
      deliveryMethods: deliveryMethods,
    }),
  ),
  on(
    OrganizationActions.getDeliveryMethodsFileTransferTypesSuccess,
    (state, { deliveryMethodsFileTransferTypes }) => ({
      ...state,
      deliveryMethodsFileTransferTypes: deliveryMethodsFileTransferTypes,
    }),
  ),
  on(
    OrganizationActions.updateDeliveryMethodSuccess,
    (state, { deliveryMethod }) => {
      const existingMethodIndex = state.deliveryMethods.findIndex(
        (method) =>
          method.deliveryMethodUID === deliveryMethod.deliveryMethodUID,
      );
      if (existingMethodIndex !== -1) {
        return {
          ...state,
          deliveryMethods: state.deliveryMethods.map((method, index) =>
            index === existingMethodIndex ? deliveryMethod : method,
          ),
          drawersState: {
            ...state.drawersState,
            deliveryMethodEditDrawer: true,
          },
        };
      } else {
        return {
          ...state,
          deliveryMethods: [...state.deliveryMethods, deliveryMethod],
          drawersState: {
            ...state.drawersState,
            deliveryMethodEditDrawer: true,
          },
        };
      }
    },
  ),
  on(
    OrganizationActions.addDeliveryMethodSuccess,
    (state, { deliveryMethod }) => ({
      ...state,
      deliveryMethods: [deliveryMethod, ...state.deliveryMethods],
      drawersState: {
        ...state.drawersState,
        deliveryMethodEditDrawer: true,
      },
    }),
  ),
  on(
    OrganizationActions.setSelectedDeliveryMethod,
    (state, { deliveryMethod }) => ({
      ...state,
      selectedDeliveryMethod: deliveryMethod,
      drawersState: {
        ...state.drawersState,
        deliveryMethodEditDrawer: false,
      },
    }),
  ),

  on(
    OrganizationActions.deleteDeliveryMethodSuccess,
    (state, { deliveryMethodUID }) => ({
      ...state,
      deliveryMethods: state.deliveryMethods.filter(
        (method) => method.deliveryMethodUID !== deliveryMethodUID,
      ),
    }),
  ),
  on(
    OrganizationActions.updateDeliveryMethodFile,
    (state, { file, parameterName }) => ({
      ...state,
      selectedDeliveryMethodFile: {
        ...state.selectedDeliveryMethodFile,
        [parameterName]: {
          message: '',
          UID: null,
          state: IFileUploadStatus.uploading,
          parameterName: parameterName,
        },
      },
    }),
  ),
  on(
    OrganizationActions.updateDeliveryMethodFileSuccess,
    (state, { fileUpload }) => ({
      ...state,
      selectedDeliveryMethodFile: {
        ...state.selectedDeliveryMethodFile,
        [fileUpload.parameterName]: fileUpload,
      },
    }),
  ),
  on(
    OrganizationActions.getTariffConfigurationsSuccess,
    (state, { organizationUID, organizationTariffConfigurationList }) => ({
      ...state,
      organizationTariffConfigurationList: organizationTariffConfigurationList,
    }),
  ),
);
